import { OwnerType, SupplierStatus } from '../constants/commonConstants';

export const checkIsInternalSourcing= (user) => {
    let userType=user?.toLowerCase();
    return userType === OwnerType.INTERNAL_SOURCE.toLowerCase();
}

export const checkIsFleetOwner= (user) => {
    let userType=user?.toLowerCase();
    return userType === OwnerType.FLEET_OWNER.toLowerCase();
}

export const checkIsFleetOwnerOrBroker= (user) => {
  let userType=user?.toLowerCase();
  return userType === OwnerType.FLEET_OWNER.toLowerCase()||userType === OwnerType.BROKER.toLowerCase();
}

export const checkIsSTOorBroker= (user) => {
  let userType=user?.toLowerCase();
  return userType === OwnerType.STO.toLowerCase() || userType === OwnerType.BROKER.toLowerCase();
}

export const checkIsSTO= (user) => {
    let userType=user?.toLowerCase();
    return userType === OwnerType.STO.toLowerCase();
}

export const checkIsBroker= (user) => {
  let userType=user?.toLowerCase();
  return userType === OwnerType.BROKER.toLowerCase();
}
export const checkIsFleetOwnerConverted= (user) => {
  let userType=user?.toLowerCase();
  return userType === OwnerType.FLEET_OWNER_C.toLowerCase();
}

export const checkIsTurkeyKazak=(country)=>{
    let countries=["turkey","kazakhstan"];
    let lowerCaseCountry=country?.toLowerCase();
    return countries.some(x=>x===lowerCaseCountry);
}

export const checkIsCountryPresent=(country)=>{
    let countries=["united arab emirates","saudi arabia",'bahrain','oman','jordan','egypt','kuwait','yemen'];
    let lowerCaseCountry=country?.toLowerCase();
    return countries.some(x=>x===lowerCaseCountry);
}

export const checkIsGCCCountry=(country)=>{
  let countries=["united arab emirates","saudi arabia",'bahrain','oman'];
  let lowerCaseCountry=country?.toLowerCase();
  return countries.some(x=>x===lowerCaseCountry);
}
export const getCurrencyCode = (country) => {
    switch (country) {
      case "United Arab Emirates":
        return "AED";
      case "Saudi Arabia":
        return "SAR";
      case "Bahrain":
        return "BHD";
      case "Turkey":
        return "TL";
      case "Oman":
        return "OMR";
      case "Jordan":
        return "JOD";
      case "Kazakhstan":
        return "KZK";
      case "Egypt":
        return "EGP";
      case "Poland":
        return "POL";
      case "India":
        return "INR";
      default:
        return "AED";
    }
};

export const checkIsDetailsPending= (userStatus) => {
  return userStatus === SupplierStatus.DETAILS_PENDING;
}

export const checkIsDetailsSubmitted= (userStatus) => {
  return userStatus === SupplierStatus.DETAILS_SUBMITTED;
}

export const checkIsDetailsPendingSubmitted= (userStatus) => {
  let status=(userStatus === SupplierStatus.DETAILS_PENDING || userStatus === SupplierStatus.DETAILS_SUBMITTED || userStatus === SupplierStatus.DETAILS_BANNED);
  return status;
}

export const checkIsDetailsBanned= (userStatus) => {
  return userStatus === SupplierStatus.DETAILS_BANNED;
}

export const checkIsBlocked= (userStatus) => {
  return userStatus === SupplierStatus.BLOCKED;
}

export const checkIsUAEOperatingCountry= (country) => {
  let userCountry=country?.toLowerCase();
  return (userCountry ==='united arab emirates' || userCountry === 'uae');
}

export const checkIsKSAOperatingCountry= (country) => {
  let userCountry=country?.toLowerCase();
  return (userCountry ==='saudi arabia' || userCountry === 'ksa');
}

export const maskPhoneNumber = (number) => {
  if (!number) return "";

  const cleaned = number.replace(/\s+/g, "");

  if (cleaned.length <= 6) return "XXXXXX";

  const visiblePart = cleaned.slice(0, cleaned.length - 6);
  return visiblePart + "XXXXXX";
};

export const checkIsPricingUnitTrucks= (pricingUnit) => {
  let localPricingUnit=pricingUnit?.toLowerCase();
  return (localPricingUnit ==='truck' || localPricingUnit === 'trucks');
}

export const checkIsPricingUnitTons= (pricingUnit) => {
  let localPricingUnit=pricingUnit?.toLowerCase();
  return (localPricingUnit ==='ton' || localPricingUnit === 'tons');
}

export const checkIsPricingUnitKMs= (pricingUnit) => {
  let localPricingUnit=pricingUnit?.toLowerCase();
  return (localPricingUnit ==='km' || localPricingUnit === 'kms');
}

export const checkIsPricingUnitMiles= (pricingUnit) => {
  let localPricingUnit=pricingUnit?.toLowerCase();
  return (localPricingUnit === 'mile' || localPricingUnit === 'miles');
}

export const checkIsPricingUnitKGs= (pricingUnit) => {
  let localPricingUnit=pricingUnit?.toLowerCase();
  return (localPricingUnit === 'kg' || localPricingUnit === 'kgs');
}

export const checkIsNewInquiryFlow= (hasBid,isMultiBiddingFlow) => {
     if(hasBid && !isMultiBiddingFlow){
      return false;
      }else{
      return true;
      }
}


export const checkIsOMANOperatingCountry= (country) => {
  let userCountry=country?.toLowerCase();
  return (userCountry ==='oman' || userCountry === 'omn');
}


export const removeUniquenessCheckForCountry= (country) => {
  let userCountry=country?.toLowerCase();
  return (userCountry ==='saudi arabia' || userCountry === 'ksa' || userCountry ==='oman' || userCountry === 'omn' ||
           userCountry ==='turkey' || userCountry ==='tur' || userCountry ==='bahrain' ||
           userCountry ==='bhr' || userCountry ==='egypt' || userCountry ==='egp');
}


// Fallback city per country, used when OCR gives us no issue city
export const DEFAULT_CITY_BY_COUNTRY = {
  "united arab emirates": "Dubai",
  uae: "Dubai",
  "saudi arabia": "Riyadh",
  ksa: "Riyadh",
  oman: "Muscat",
  bahrain: "Manama",
  jordan: "Amman",
  turkey: "Istanbul",
  kazakhstan: "Almaty",
};

export const getDefaultCityForCountry = (country) =>
  DEFAULT_CITY_BY_COUNTRY[country?.trim()?.toLowerCase()] || "";


// OCR spells city names loosely ("RAS AL KHAIMA" for "Ras Al Khaimah"), so
// compare on letters and digits only, ignoring case, spaces and punctuation.
const normalizeCityName = (value = "") =>
  String(value || "")
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "");

// Levenshtein distance, used to allow a near miss on longer city names
const editDistance = (a = "", b = "") => {
  const row = Array.from({ length: b.length + 1 }, (_, i) => i);
  for (let i = 1; i <= a.length; i++) {
    let diagonal = row[0];
    row[0] = i;
    for (let j = 1; j <= b.length; j++) {
      const previousDiagonal = row[j];
      row[j] = Math.min(
        row[j] + 1,
        row[j - 1] + 1,
        diagonal + (a[i - 1] === b[j - 1] ? 0 : 1)
      );
      diagonal = previousDiagonal;
    }
  }
  return row[b.length];
};

// Finds a city in the master list, tolerating the spelling variants OCR returns.
// Returns the master entry itself so callers can use its exact name.
export const findMatchingCity = (cityList, cityName) => {
  const target = normalizeCityName(cityName);
  if (!target || !cityList?.length) return undefined;

  const entries = cityList.map((city) => ({
    city,
    name: normalizeCityName(city?.name),
  }));

  // An exact spelling always wins over any near match
  const exact = entries.find((entry) => entry.name === target);
  if (exact) return exact.city;

  // Then one name being a prefix of the other, e.g. "rasalkhaima(h)"
  const prefix = entries.find(
    (entry) =>
      entry.name.length >= 4 &&
      (entry.name.startsWith(target) || target.startsWith(entry.name))
  );
  if (prefix) return prefix.city;

  // Then one name containing the other. The master decorates names with
  // articles and suffixes ("Al Fujairah City" for "Fujairah").
  if (target.length >= 5) {
    // Shortest wins, so "Fujairah" prefers "Al Fujairah City" over
    // "Dibba Al-Fujairah" instead of whichever the list happens to hold first
    const [contained] = entries
      .filter(
        (entry) =>
          entry.name.length >= 5 &&
          (entry.name.includes(target) || target.includes(entry.name))
      )
      .sort((a, b) => a.name.length - b.name.length);
    if (contained) return contained.city;
  }

  // Finally a small typo tolerance, scaled to the length of the name
  const tolerance = target.length > 8 ? 2 : 1;
  const closest = entries
    .map((entry) => ({ ...entry, distance: editDistance(entry.name, target) }))
    .sort((a, b) => a.distance - b.distance)[0];

  return closest && closest.distance <= tolerance ? closest.city : undefined;
};


// Language spoken per nationality, anything unlisted falls back to English
export const DEFAULT_LANGUAGE_NAME = "English";

export const LANGUAGE_BY_NATIONALITY = {
  india: "Hindi",
  nepal: "Hindi",
  pakistan: "Urdu",
  turkey: "Turkish",
  kazakhstan: "Russian",
  "saudi arabia": "Arabic",
  ksa: "Arabic",
  "united arab emirates": "Arabic",
  uae: "Arabic",
  oman: "Arabic",
  bahrain: "Arabic",
  jordan: "Arabic",
  egypt: "Arabic",
  syria: "Arabic",
  kuwait: "Arabic",
};

export const getLanguageByNationality = (nationality) =>
  LANGUAGE_BY_NATIONALITY[nationality?.trim()?.toLowerCase()] ||
  DEFAULT_LANGUAGE_NAME;


export const toTitleCase = (val = "") => {
  return val
    .toLowerCase()
    .split(" ") // split only on spaces
    .map(word =>
      word
        .split(".") // split on dots
        .map(dotPart =>
          dotPart
            .split("-") // split on hyphens
            .map(part => part.charAt(0).toUpperCase() + part.slice(1))
            .join("-") // rejoin with hyphen
        )
        .join(".") // rejoin with dot
    )
    .join(" "); // rejoin with space
};


